import { render, staticRenderFns } from "./ProfileFacts.vue?vue&type=template&id=4dbeb707&"
import script from "./ProfileFacts.vue?vue&type=script&lang=js&"
export * from "./ProfileFacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports